require("./pagination.scss");